export default {"src":"/_next/static/media/handsClapping_24.b5bf39f0.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};